import AuthRoutes from '@/auth/routes';
import DashboardRoutes from '@/dashboard/routes';
import UsersRoutes from '@/users/routes';
import PropertyRoutes from '@/properties/routes';
import UnitTypeRoutes from '@/_unit-types/routes';
import UnitRoutes from '@/units/routes';
import EmployeeRoutes from '@/employees/routes';
import EvalQuestionRoutes from '@/eval-questions/routes';
import TitleRoutes from '@/titles/routes';
import EvalRoutes from '@/evals/routes';
import ReportsRoutes from '@/delinquencies/routes';
import DocumentsRoutes from '@/documents/routes';
import NotaryRoutes from '@/notaries/routes';
import LawyerRoutes from '@/lawyers/routes';
import DepartmentRoutes from '@/departments/routes';
import OrderRoutes1 from '../src/components/_orders/routes';
import RenewalsRoutes from '@/renewals/routes';
import MatrixRoutes from '@/matricies/routes';
import PortfolioRoutes from '@/portfolio/routes';
import ScriptsRoutes from '@/scripts/routes';
import OrderRoutes from '../src/components/orders/routes';
import UnitTypesRoutes from '../src/components/unit-types/routes';
import ReportsVersionRoutes from '../src/components/reports-version/routes';

const routes = [
    ...AuthRoutes,
    ...DashboardRoutes,
    ...UsersRoutes,
    ...PropertyRoutes,
    ...UnitTypeRoutes,
    ...UnitRoutes,
    ...EmployeeRoutes,
    ...EvalQuestionRoutes,
    ...TitleRoutes,
    ...EvalRoutes,
    ...ReportsRoutes,
    ...DocumentsRoutes,
    ...NotaryRoutes,
    ...LawyerRoutes,
    ...DepartmentRoutes,
    ...OrderRoutes1,
    ...OrderRoutes,
    ...RenewalsRoutes,
    ...MatrixRoutes,
    ...PortfolioRoutes,
    ...ScriptsRoutes,
    ...UnitTypesRoutes,
    ...ReportsVersionRoutes
];

export default routes;
